import React from 'react'
import Find from '../share/components/Find/Find'
import CarouselServices,{servicesTravel} from '../share/components/CarouselServices/CarouselSevices'
import ButtonsFilters from './buttonsFilters/ButtonsFilters'
import UseHealthWellness from '../../viewModels/HealthWellness/UseHealthWellness'
import AllCardsHealth from './AllCardHealth/AllCardsHealth'
import Paginado from './Paginado/Paginado'

const HealtWellness = () => {

  const {
    dataHealth,
    urlImage,
    currentPage,
    nextHandler,
    prevHandler,
    mostrarNext,
    services,
    loading,
    personalizeFind,
    detailHealth
  } = UseHealthWellness()
  return (
    <div>
        <Find/>
        <CarouselServices current={servicesTravel[9].title}/>
        <ButtonsFilters personalizerFind={personalizeFind}/>
        <AllCardsHealth dataHealth={dataHealth} loading={loading} urlImage={urlImage} detailHealth={detailHealth}/>
        <Paginado currentPage={currentPage} data={services} mostrarNext={mostrarNext} nextHandler={nextHandler} prevHandler={prevHandler}/>
    </div>
  )
}

export default HealtWellness